import React, { useEffect, useState } from "react";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAll,
  setAuthDetails,
} from "../../../Redux/Slices/counterSlice";
import { handleLoginResponse } from "../../../utils/handleLoginResponse";
import Email from "./email";
import VerifyOtp from "./verifyOtp";


export default function EmailPhoneVerification() {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  const postLoginRedirect = location.state?.redirectTo;
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const showSnackbar = useSnackbar();
  const role = searchParams.get("role") || "";
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loginContent, setLoginContent] = useState({});
    const { loginDetails } = useSelector((state) => state.counter);

  // useEffect(() => {
  //   console.log(loginDetails)
  //   if (loginDetails?.jwt) {
  //     if (loginDetails?.userType === "normal user") {
  //       navigate("/customer-home");
  //     } else if (loginDetails?.userType === "admin") {
  //       navigate("/app/analytics-dashboard");
  //     } else if (loginDetails?.userType === "delivery person") {
  //       navigate("/delivery/earnings-dashboard");
  //     } else {}
  //   }
  // }, [])

  const handleEmailContinue = (loginData) => {
    setLoginContent(loginData);
    let payload =
      loginData.type === "email"
        ? { email: loginData.value }
        : { mobileNumber: loginData.value };

    axiosInstance
      .post("/auth/request-otp", payload)
      .then(() => {
        dispatch(
          setAuthDetails({
            email: loginData.type === "email" ? loginData.value : "",
            mobile: loginData.type === "phone" ? loginData.value : "",
            role: role,
            type: loginData.type,
          })
        );
        setStep(2);
      })
      .catch((error) => {
        showSnackbar("Something went wrong with email!", "error");
      });
  };

  const handleOtpVerify = () => {
    const otpCode = otp.join("");
    if (otpCode.length !== 6) return;

    const payload =
      loginContent.type === "email"
        ? { email: loginContent.value, otp: otpCode }
        : { mobileNumber: loginContent.value, otp: otpCode };
    if (otpCode.length === 6) {
      const query = role ? `?userType=${encodeURIComponent(role)}` : "";
      const url = `/auth/verify-otp${query}`;
      axiosInstance
        .post(`/auth/verify-otp${query}`, payload, {
          skipAuthInterceptor: true,
        })
        .then((res) => {
          handleLoginResponse({
            responseData: { ...res.data.payload, token: res.data.token },
            token: res.data.token,
            dispatch,
            navigate,
            showSnackbar,
            redirectTo: postLoginRedirect,
          });
        })
        .catch((error) => {
          if (error?.response?.data?.statusCode == 401) {
            showSnackbar("Please enter valid OTP", "error");
          } else {
            showSnackbar("Something went wrong!", "error");
          }
        });
    }
  };

  return (
    <>
      {step === 1 && (
        <Email
          onContinue={handleEmailContinue}
          role={role}
        />
      )}
      {step === 2 && (
        <VerifyOtp
          loginContent={loginContent}
          otp={otp}
          setOtp={setOtp}
          onVerify={handleOtpVerify}
          onResend={(data) => handleEmailContinue(data)}
          handleBack={() => setStep(1)}
        />
      )}
    </>
  );
}

